var T = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
var f = (r, t, o) => t in r ? T(r, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[t] = o, l = (r, t) => {
  for (var o in t || (t = {}))
    p.call(t, o) && f(r, o, t[o]);
  if (i)
    for (var o of i(t))
      a.call(t, o) && f(r, o, t[o]);
  return r;
};
var s = (r, t) => {
  var o = {};
  for (var e in r)
    p.call(r, e) && t.indexOf(e) < 0 && (o[e] = r[e]);
  if (r != null && i)
    for (var e of i(r))
      t.indexOf(e) < 0 && a.call(r, e) && (o[e] = r[e]);
  return o;
};
import { jsx as d } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { T as x } from "../../Title-D_D6eyDg.js";
const c = n((e, o) => {
  var m = e, {
    className: r
  } = m, t = s(m, [
    "className"
  ]);
  return /* @__PURE__ */ d(
    x,
    l({
      className: r,
      ref: o
    }, t)
  );
});
c.displayName = "Title";
export {
  c as Title
};
